import React from 'react';
import './FiltersLabel.scss';

// The "Filters" caption that becomes "Clear all" once something is selected. Both states are the
// same element with the same box (a link-style button, zero padding, reserved width), so the chips
// next to it never shift when the caption flips.
const FiltersLabel = ({ active, onClear }) => (
    <button
        type="button"
        className="filters-label btn btn-link p-0 text-decoration-none text-white"
        disabled={!active}
        onClick={active ? onClear : undefined}
    >
        <span className={`fas ${active ? 'fa-filter-circle-xmark' : 'fa-filter'} me-1 text-primary`}/>
        {active ? ' Clear all' : ' Filters'}
    </button>
);

export default FiltersLabel;
